export default __webpack_public_path__ + "static/media/ic_eth_16.6f38e6f3.svg";